import { render, staticRenderFns } from "./Toolbox.vue?vue&type=template&id=039b6464&scoped=true&"
import script from "./Toolbox.vue?vue&type=script&lang=js&"
export * from "./Toolbox.vue?vue&type=script&lang=js&"
import style0 from "./Toolbox.vue?vue&type=style&index=0&id=039b6464&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039b6464",
  null
  
)

export default component.exports